import React, {useState} from "react";

import {useTranslation} from "react-i18next";

import Button from "@mui/material/Button";
import { ArrowForward as ArrowForwardIcon } from '@vedmarket/ui-kit';

import ModalSettingsNotFound from "./components/not-found";
import ModalSettingsNew from "./components/new";
import ModalSettingsList from "./components/list";
import ModalBig from "../../../../../common/modalBig";

type Props = {
    isOpen: boolean
    onClose(): void
}

const enum CURRENT_STEP {
    NOT_FOUND = 'NOT_FOUND',
    NEW = 'NEW',
    LIST = 'LIST'
}

const ModalSettings = ({isOpen, onClose}: Props) => {

  const { t } = useTranslation()

  const [ currentStep, setCurrentStep ] = useState(CURRENT_STEP.NEW);

  const getDescription = (step: CURRENT_STEP) => {
    switch (step) {
      case CURRENT_STEP.NOT_FOUND:
        return <ModalSettingsNotFound/>;
      case CURRENT_STEP.NEW:
        return <ModalSettingsNew onClose={onClose}/>;
      case CURRENT_STEP.LIST:
        return <ModalSettingsList onClose={onClose} goToNewTemplate={goToNewTemplate}/>;
      default:
        return <ModalSettingsList onClose={onClose} goToNewTemplate={goToNewTemplate}/>;
    }
  }

  const getTitle = (step: CURRENT_STEP) => {
    switch (step) {
      case CURRENT_STEP.NOT_FOUND:
        return t('calc__text__summary__finalReportDisplaySettings');
      case CURRENT_STEP.NEW:
        return `${t('calc__text__summary__finalReportDisplaySettings')}. ${t('calc__text__summary__newTemplate')}`;
      default:
        return t('calc__text__summary__finalReportDisplaySettings');
    }
  }

  const getWidth = (step: CURRENT_STEP) => {
    switch (step) {
      case CURRENT_STEP.NEW:
        return 1392;
      case CURRENT_STEP.LIST:
        return 1168;
      default:
        return undefined;
    }
  }

  const goToNewTemplate = () => {
    setCurrentStep(CURRENT_STEP.NEW);
  }

  return <ModalBig
    isOpen={isOpen}
    onClose={onClose}
    title={getTitle(currentStep)}
    width={getWidth(currentStep)}
    noPadding={true}
    customStyles={{
      minWidth: currentStep === CURRENT_STEP.NEW ? 1392 : 'auto',
    }}
    buttons={currentStep === CURRENT_STEP.NOT_FOUND ? <div className='modal-common__actions'>
      <Button
        variant='outlined'
        sx={{ minWidth: '238px', marginRight: 3}}
        onClick={onClose}
      >{t('actions__text__cancel')}</Button>
      <Button
        variant='contained'
        onClick={() => setCurrentStep(CURRENT_STEP.NEW)}
        endIcon={<ArrowForwardIcon />}
        fullWidth
      >{t('calc__text__summary__createANewReportTemplate')}</Button>
    </div> : undefined}
  >
    {getDescription(currentStep)}
  </ModalBig>
}

export default ModalSettings
